import { isProduction } from "@/lib/appEnvironment";
import { useAuthStore } from "@/store/authStore";
import { UserRole } from "@/types";

export function useEnvironmentBannerState() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);

  const isAdmin = user?.role === UserRole.ADMIN;
  const showNonProductionBanner = !isProduction;
  const showProductionAdminBanner =
    isProduction && isAuthenticated && isAdmin;
  const visible = showNonProductionBanner || showProductionAdminBanner;

  return { visible, showProductionAdminBanner, showNonProductionBanner };
}
